import { users } from "./mockup/users";
import { signIn, getUser, cognitoSubject$ } from "./authService";
import { GET } from "../request/service";
import { getDashboardList, getSendMsgToken } from "../request/api";
export type TUser = {
  avatar?: string;
  name?: string;
  username?: string;
  email?: string;
  role?: string;
};

interface AuthProvider {
  isAuthenticated: boolean;
  user: null | TUser;
  dashboardList: Promise<{ DashboardId: string; Name: string }>[];
  signin(username: string, password: string | null): Promise<boolean>;
  signout(): Promise<void>;
  buildCognito(): void;
}

/**
 * This represents some generic auth provider API, like Firebase.
 */
// export const authProvider: AuthProvider = {
//   isAuthenticated: false,
//   user: null,
//   async signin(username: string, password: string | null) {
//     await new Promise((r) => setTimeout(r, 500)); // fake delay
//     const user = users.find(
//       (x) =>
//         (x.username === username || x.email === username) &&
//         x.password === password,
//     );
//     if (user) {
//       authProvider.isAuthenticated = true;
//       authProvider.user = user;
//       return true;
//     }
//     return false;
//   },
//   async signout() {
//     await new Promise((r) => setTimeout(r, 500)); // fake delay
//     authProvider.isAuthenticated = false;
//     authProvider.user = null;
//   },
// };

export const authProvider: AuthProvider = {
  isAuthenticated: false,
  user: null,
  dashboardList: [],
  async signin(username: string, password: string) {
    await new Promise((r) => setTimeout(r, 500)); // fake delay

    try {
      this.buildCognito();
      const session = await signIn(username, password);
      console.log("Sign in successful", session);
      if (session && typeof session.AccessToken !== "undefined") {
        localStorage.setItem("accessToken", session.AccessToken);
        console.log(localStorage.getItem("accessToken"));
        if (localStorage.getItem("accessToken")) {
          let user_info = null;
          let accessToken = localStorage.getItem("accessToken");
          if (accessToken !== null) {
            const userInfo = await getUser(accessToken);
            console.log(userInfo);
            user_info = userInfo;
          } else {
            console.log("Access token is null");
          }

          if (user_info !== null) {
            localStorage.setItem("userName", user_info.Username || "");
            const defaultDashboardList = await GET(
              getDashboardList + "?name=" + user_info.Username,
              "",
            ).then((res: any) => {
              return res;
            });
            const user: TUser = {
              avatar: user_info.Username,
              name: user_info.Username,
              username: user_info.Username,
              email: user_info.Username,
              role: "admin",
            };
            console.log(user);
            if (user) {
              authProvider.isAuthenticated = true;
              authProvider.user = user;
              authProvider.dashboardList = defaultDashboardList?.dashboardList;
              localStorage.setItem(
                "dashboardList",
                JSON.stringify(defaultDashboardList.dashboardList),
              );
              return true;
            }
          }
        } else {
          console.error("Session token was not set properly.");
          return false;
        }
      } else {
        console.error("SignIn session or AccessToken is undefined.");
        return false;
      }
    } catch (error) {
      // alert(`Sign in failed: ${error}`);
      return false;
    }

    return false;
  },
  async signout() {
    await new Promise((r) => setTimeout(r, 500)); // fake delay
    authProvider.isAuthenticated = false;
    authProvider.user = null;
  },

  async buildCognito() {
    console.log("-----------Building Cognito Start----------");
    GET(getSendMsgToken, {
      timeout: 200000,
    }).then(() => {
      cognitoSubject$.next(true);
      localStorage.setItem("cognitoSubject", "true");
      console.log("-----------Building Cognito End----------");
    });
  },
};
